import script from "./object_importantMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./object_importantMessage.vue?vue&type=script&setup=true&lang=js"

import "./object_importantMessage.vue?vue&type=style&index=0&id=5e7ca9a9&scoped=true&lang=scss"

import exportComponent from "/home/dmytro/Projects/gcs/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e7ca9a9"]])

export default __exports__